<template>
    <div class="rightContentBox">
        <div class="rightContent content_right">
            <div class="right_bar">
                <div class="search_header search">
                    <div class="search">
                        <div class="search_box"></div>
                        <div class="search_placeholder"></div>
                        <div class="navbarUser search_user">
                            <div class="bar_avatar_box" @click="handleLogin">
                                <div class="bar_avatar_name">{{ isLogin ? userInfo.nickname : '立即登录' }}</div>
                                <img class="bar_avatar_img"
                                    :src="isLogin ? userInfo.avatar + '?id=' + imgRandom : require('@/assets/image/login_icon.png')"
                                    alt="">
                                <div class="loout_box" v-if="showLogin">
                                    <div class="loout_item" @click="handelOption('user')"><i class="user_mes"></i>个人中心
                                    </div>
                                    <div class="loout_item" @click="handelOption('logout')"><i class="loginout"></i>退出登录
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- todo---动态padding -->
            <div class="right_holder" style="padding-top: 0px;"></div>
            <!-- todo---动态top&bottom -->
            <div class="right_content">
                <!-- 右边栏游戏---内容 -->
                <div class="right_content_list_box">
                    <div class="right_content_bar">
                        <div class="right_content_bar_box">
                            <div class="label">
                                <span>近期游戏</span>
                            </div>
                            <div class="more">
                                <!-- <span>更多</span>
                                <img src="@/assets/image/detail_into_icon.png" alt=""> -->
                            </div>
                        </div>
                    </div>
                    <div class="right_content_list" v-if="rankGameList && rankGameList.length > 0">
                        <div class="commonGameIntro" v-for="(itemRelease, index) in rankGameList"
                            @click="checkGameDes(itemRelease.gid)" :key="'commonGameIntro' + index">
                            <div class="gameLogo left_box">
                                <div class="logo">
                                    <img :src="itemRelease.icon_url" alt="">
                                    <div class="game_icon_tips"
                                        v-for="(itemicon, indexes) in itemRelease.icon_check_box" :key="indexes">
                                        <div v-if="itemicon === '0.1产品'" class="discount_icon">
                                            <img src="@/assets/image/discount.png" alt="" />
                                        </div>
                                        <div v-if="itemicon === '加速'" class="speed_icon">
                                            <img src="@/assets/image/speed.png" alt="" />
                                        </div>
                                        <div v-if="itemicon === '专服'" class="service_icon">
                                            <img src="@/assets/image/specialized_service.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <div class="info_box">
                                    <div class="centerBox centerBox_3">
                                        <div class="game_name">
                                            <div class="name">{{ itemRelease.show_name || itemRelease.game_name }}</div>
                                        </div>
                                        <div class="game_lable">
                                            <div class="info info2">
                                                <div class="label" v-for="itemGame in itemRelease.game_tags"
                                                    :key="itemGame.id">
                                                    <span class="tag_item">{{ itemGame.text
                                                        }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="button_box">
                                    <div class="rightBox">
                                        <div class="content">
                                            <div class="x7Discount x7Discount_green">
                                                <div class="game_mes_rt">
                                                    <img class="new_outfit" v-if="itemRelease.is_server_rebate"
                                                        src="@/assets/image/new_outfit_icon.png" alt="">
                                                    <img class="free_edition_2" v-if="itemRelease.is_free == 1"
                                                        src="@/assets/image/btn_icon2.png" alt="">
                                                    <template v-else-if="itemRelease.discount_img_url">
                                                        <img class="free_edition_2" :src="itemRelease.discount_img_url"
                                                            alt="">
                                                        <p class="discount"
                                                            v-if="itemRelease.rebate_type == 2 && itemRelease.discount_img_url">
                                                            {{
                                                                itemRelease.first_rebate | getRoundedNumber }}</p>
                                                    </template>
                                                    <div v-else class="game_btn">{{ itemRelease.first_rebate |
                                                        getRoundedNumber }}<span>折</span></div>
                                                </div>
                                                <!-- <div class="small" :class="index == 1 ? 'small_bg_box' : ''">
                                                    <div class="num">0.1</div>
                                                    <div class="text">折</div>
                                                    <img class="small_bg" v-if="index == 1"
                                                        src="@/assets/image/bt_icon.png" alt="">
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 右边栏备案---内容 -->
                <div class="right_content_footer">
                    <div class="info_box box">
                        <div class="record">
                            <div>
                                <!-- 公安备案： <a class="clickText" target="_blank"
                                    href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030602002894">
                                    粤公网安备
                                    45698318851 号 </a> -->
                                <!-- <br>  -->
                                网站备案： <a class="clickText" target="_blank" href="http://beian.miit.gov.cn/">
                                    苏ICP备2020071003号-5A 号 </a>
                            </div>
                        </div>
                        <span v-if="showMore">
                            <!-- <div>网络文化经营许可证编号：粤网文[2018]1234-456 8号</div> -->
                            <!-- <div>增值电信业务经营许可证：粤B2-20250000</div> -->
                            <div class="license"><span>企业营业执照</span><img src="@/assets/image/zhao.png"
                                    class="license_img" alt="营业执照图片">
                            </div>
                            <div class="company"><a class="clickText" target="_blank"
                                    href="https://www.shangminet.com/">
                                    广州旭扬网络科技有限公司 </a><br> 注册地址： <a class="clickText" target="_blank" href="">
                                    广州市黄埔区科学大道C3栋飞鸟时代 </a></div>
                            <div class="btns"><a class="clickBtn" href="#">联系客服</a><a class="clickBtn" href="#"> 商务合作
                                </a><a class="clickBtn" href="#">廉洁举报</a></div>
                            <div class="dev_info">
                                <div>开发者：广州旭扬网络科技有限公司</div>
                                <div>版本号：v1.0.0</div>
                            </div>
                            <div class="btns"><a class="clickBtn cursor"
                                    href="http://yapisdk.50pk.com/storage/agreement/v1/privacy.html" target="_blank">
                                    应用权限 </a><a class="clickBtn"
                                    href="http://yapisdk.50pk.com/storage/agreement/v1/user.html" target="_blank"> 隐私协议
                                </a></div>
                        </span>
                        <div class="more" @click="showMore = !showMore">
                            <span>全部</span><span>{{ showMore ? '收起' : '展开' }}</span><img src="@/assets/image/up_into_icon.png"
                                :class="showMore ? '' : 'upward'" alt=""></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { postData } from '@/api/api.js'
import formatTime from "@/filters/index.js";
import Bus from '@/util/Bus'
export default {
    name: 'RightContent',
    data() {
        return {
            showMore: false,
            showLogin: false,
            userInfo: {},
            isLogin: false,
            rankGameList: []
        }
    },
    created() {
        const userInfo = window.localStorage.getItem('userInfo')
        this.userInfo = userInfo ? JSON.parse(userInfo) : {}
        const isLogin = localStorage.getItem('loginMes') === 'true';
        this.isLogin = isLogin ? isLogin : false
        this.fetchData()
    },
    mounted() {
        // 登录弹窗
        Bus.$on("uploadData", () => {
            const userInfo = window.localStorage.getItem('userInfo')
            this.userInfo = userInfo ? JSON.parse(userInfo) : {}
            const isLogin = localStorage.getItem('loginMes') === 'true';
            this.isLogin = isLogin ? isLogin : false
            console.log(isLogin, "isLogin----right")
            this.$forceUpdate()
        });
    },
    computed: {
        ...mapState(["imgRandom", 'platform']),
    },
    methods: {
        ...mapMutations(['clearLoggedInUser', 'handelUid', 'handelSdkGid']),
        formatting(time, type = 0) {
            return formatTime.formatTime9(time, type)
        },
        handleLogin() {
            if (this.isLogin) {
                this.showLogin = !this.showLogin
            } else {
                // 打开登录弹窗
                Bus.$emit("loginShow", true);
            }
        },
        handelOption(type) {
            if (type === 'user') {
                this.$router.push('/my')
            } else {
                this.logout()
            }
        },
        logout() {
            window.localStorage.removeItem("access_token");
            window.localStorage.removeItem("refresh_token");
            window.localStorage.removeItem("userInfo");
            window.localStorage.removeItem("loginMes");
            this.handelUid(0)
            this.handelSdkGid(0)
            this.clearLoggedInUser()
            window.location.reload(true);
        },
        async fetchData() {
            const endpoint = '/box/tabs'
            const params = {
                tab: 3,
                subchannelnum: 0,
                platform: this.platform,
            }
            const res = await postData(endpoint, params)
            if (res?.code === 0) {
                if (res.data.length >= 6) {
                    this.rankGameList = res.data.slice(0, 6); // 截取前6个元素
                } else {
                    this.rankGameList = res.data; // 如果小于6个，直接赋值
                }
            }
        },
        checkGameDes(id) {
            this.$router.push({
                path: '/gameDetail',
                query: { id: id, Date: new Date().getTime() }
            })
        }
    },
}
</script>
<style lang="less" scoped>
.rightContentBox {
    position: sticky;
    top: 0;
    width: 360px;
    z-index: 99;
    height: 100vh;
    overflow: auto;
}

// 右边栏
.rightContent {
    position: relative;

    .right_bar {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
        background: #ffffff;
        z-index: 300;
        position: sticky;
        top: 0;

        .search {
            flex: 1;
        }

        .search_header {
            position: relative;

            .search {
                display: flex;
                align-items: center;

                .search_box {
                    display: none;
                    align-items: center;
                    justify-content: flex-start;
                    flex-direction: row;
                    flex: 1;
                    height: 40px;
                    border-radius: 20px;
                    background: #fff;
                    padding: 6px 11px 6px 16px;
                    font-weight: 400;
                    box-sizing: border-box;
                }

                .search_placeholder {
                    width: 40px;
                    height: 40px;
                    margin-left: 14px;
                }

                .navbarUser {
                    position: relative;

                    .bar_avatar_box {
                        position: relative;
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        .bar_avatar_name {
                            font-size: 14px;
                            color: #666;
                        }

                        .bar_avatar_img {
                            width: 36px;
                            height: 36px;
                            border: 2px solid #ffffff;
                            border-radius: 50%;
                            margin-left: 14px;
                        }

                        .loout_box {
                            position: absolute;
                            bottom: -98px;
                            right: 0;
                            padding: 5px;
                            box-sizing: border-box;
                            border-radius: 8px;
                            background-color: #ffffff;
                            box-shadow: 0 0 40px rgba(0, 0, 0, .1);

                            .loout_item {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 116px;
                                height: 40px;
                                white-space: nowrap;
                                font-size: 14px;
                                color: rgba(0, 0, 0, 0.6);
                                border-radius: 5px;

                                i {
                                    display: inline-block;
                                    margin-right: 10px;
                                    background-size: cover;
                                }

                                .user_mes {
                                    background-image: url("@/assets/image/account_icon.png");
                                    width: 18px;
                                    height: 18px;
                                }

                                .loginout {
                                    background-image: url("@/assets/image/logout.png");
                                    width: 14px;
                                    height: 14px;
                                }

                                &:last-of-type {
                                    margin-bottom: 0;
                                }

                                &:hover {
                                    background-color: rgba(0, 0, 0, .1);
                                }
                            }
                        }
                    }
                }

                .search_user {
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 6;
                }
            }
        }
    }

    .right_content {
        position: -webkit-sticky;
        position: sticky;
        top: 80px;
        z-index: 1;
        margin-bottom: 40px;

        // 右边栏游戏
        .right_content_list_box {
            padding: 10px 14px 24px 20px;
            margin-bottom: 16px;
            box-sizing: border-box;
            background: #F5F5F5;
            border-radius: 20px;

            .right_content_bar {
                height: 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .right_content_bar_box {
                    width: 100%;
                    height: auto;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 18px;

                    .label {
                        font-size: 16px;
                        font-weight: 400;
                        color: #333;
                        display: flex;
                    }

                    .more {
                        flex: 1;
                        min-width: 12px;
                        color: #999;
                        font-size: 13px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 4px 12px 0 0;

                        span {
                            flex: 1;
                            text-align: right;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                        }

                        img {
                            width: 12px;
                            height: 22px;
                            margin-left: 4px;
                            margin-top: 2px;
                        }
                    }
                }
            }

            .right_content_list {
                cursor: pointer;
                margin-top: 12px;

                .commonGameIntro {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: start;
                    cursor: pointer;
                    margin-top: 24px;

                    &:first-of-type {
                        margin-top: 0;
                    }

                    .gameLogo {
                        width: 70px;
                        height: 70px;
                        border-radius: 20px;
                        position: relative;

                        .logo {
                            >img {
                                width: 70px;
                                height: 70px;
                                border-radius: 20px;
                            }

                            .game_icon_tips {
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 70px;
                                height: 70px;

                                >div {
                                    width: 70px;
                                    height: 70px;

                                    >img {
                                        width: 70px;
                                        height: 70px;
                                    }
                                }
                            }
                        }
                    }

                    .left_box {
                        flex-shrink: 0;
                    }

                    .content {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        flex: 1 1 auto;
                        // overflow: hidden;

                        .info_box {
                            overflow: hidden;
                            max-width: 160px;

                            .centerBox {
                                margin-left: 12px;
                                margin-right: 12px;

                                .game_name {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    justify-content: start;
                                    max-width: 250px;
                                    font-size: 19px;
                                    line-height: 24px;
                                    font-weight: 400;
                                    color: #333;

                                    .name {
                                        font-size: 16px;
                                        line-height: 20px;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                    }
                                }

                                .info {
                                    display: flex;
                                    margin-top: 4px;

                                    .label {
                                        display: inline-block;
                                        padding: 5px;
                                        box-sizing: border-box;
                                        margin-right: 4px;
                                        background-color: #FEF3DE;
                                        color: #FF8000;
                                        font-size: 11px;
                                        border-radius: 6px;
                                        white-space: nowrap;
                                    }
                                }
                            }

                        }

                        .button_box {
                            flex-shrink: 0;

                            .rightBox {
                                flex-shrink: 0;
                                width: 72px;
                                // overflow: hidden;

                                .content {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;

                                    .x7Discount .small {
                                        display: flex;
                                        flex-direction: row;
                                        align-items: center;
                                        justify-content: center;
                                        width: 50px;
                                        height: 24px;
                                        border-radius: 24px;
                                        background: #FF3838;

                                        .num,
                                        .text {
                                            position: relative;
                                            font-family: Source-Han-Sans-K-Blod;
                                            font-size: 12px;
                                            color: #fff;
                                            z-index: 2;
                                            // letter-spacing: -1px;
                                        }
                                    }

                                    .x7Discount .small_bg_box {
                                        position: relative;
                                        background: #ffffff;

                                        .num {
                                            margin-left: 2px;
                                            color: #FF3838;
                                        }

                                        .text {
                                            margin-left: 8px;
                                        }

                                        .small_bg {
                                            width: 50px;
                                            height: 24px;
                                            position: absolute;
                                            top: 0;
                                            left: 0;
                                            z-index: 1;
                                        }
                                    }

                                    .x7Discount .game_mes_rt {
                                        position: relative;

                                        .new_outfit {
                                            position: absolute;
                                            top: -10px;
                                            left: 50%;
                                            transform: translate(-50%, 0);
                                            width: 40px;
                                            height: 17px;
                                        }

                                        .game_btn {
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            font-size: 12px;
                                            color: #ffffff;
                                            font-weight: 700;
                                            width: 50px;
                                            height: 24px;
                                            border-radius: 16px;
                                            background-color: #FF3838;

                                            >span {
                                                font-size: 10px;
                                            }
                                        }

                                        // 除去每日推荐--游戏0.1折按钮样式
                                        .discount {
                                            position: absolute;
                                            color: #FF3838;
                                            font-family: "DIN";
                                            font-size: 12px;
                                            font-weight: bold;
                                            top: 48%;
                                            left: 36%;
                                            transform: translate(-50%, -50%);
                                        }

                                        .free_edition_2 {
                                            width: 58px;
                                            height: 32px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        // 右边栏备案
        .right_content_footer {
            a {
                color: rgba(0, 0, 0, 0.6);
            }

            .info_box {
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.6);
                line-height: 24px;

                .license {
                    display: flex;
                    align-items: center;
                }

                .company,
                .btns,
                .dev_info {
                    margin-top: 16px;
                }

                .clickBtn {
                    margin-right: 16px;
                }
            }

            .box {
                text-align: left;
                background: #F5F5F5;
                border-radius: 20px;
                padding: 18px 20px 20px;
            }

            .more {
                display: flex;
                align-items: center;
                margin-top: 16px;
                font-size: 14px;
                line-height: 24px;
                font-weight: 400;
                color: #999;
                cursor: pointer;

                .upward {
                    transform: rotate(180deg);
                    -webkit-transform: rotate(180deg);
                }

                img {
                    width: 16px;
                    height: 12px;
                    margin-left: 4px;
                }
            }
        }
    }
}

// 右边栏适配
@media (min-width: 1144px) {
    .rightContentBox {
        width: 340px;
    }
}

@media (min-width: 0px) and (max-width: 1144px) {
    .rightContentBox {
        display: none;
    }
}
</style>
